import { en, type Catalog, type MessageKey } from './en.js';
import { tr } from './tr.js';

export type AppLocale = 'en' | 'tr';
export type { Catalog, MessageKey };

const CATALOGS: Readonly<Record<AppLocale, Catalog>> = { en, tr };

/** Typed formatter: {param} placeholders replaced from params. */
export function translate(
  locale: AppLocale,
  key: MessageKey,
  params?: Readonly<Record<string, string | number>>,
): string {
  const template = CATALOGS[locale][key] ?? en[key];
  if (params === undefined) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in params ? String(params[name]) : match,
  );
}
